
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface CertificationSummaryCardProps {
  totalUploaded: number;
  completedRequired: number;
  requiredCount: number;
}

export const CertificationSummaryCard = ({ 
  totalUploaded, 
  completedRequired, 
  requiredCount 
}: CertificationSummaryCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          Required Documentation
          <div className="flex items-center gap-2 text-sm">
            <Badge variant="outline">
              {totalUploaded} docs uploaded
            </Badge>
            <Badge variant={completedRequired === requiredCount ? "default" : "secondary"}>
              {completedRequired}/{requiredCount} required complete
            </Badge>
          </div>
        </CardTitle>
      </CardHeader>
    </Card>
  );
};
